import type { ReactNode } from "react";

interface TableVisualIndicatorProps {
  children: ReactNode;
}

/** Full-height branded presentation for a table's visual-indicator column. */
export function TableVisualIndicator({ children }: TableVisualIndicatorProps): ReactNode {
  return (
    <div className="flex size-full items-center justify-center bg-background-brand px-space-sm text-text-default-inverse">
      {children}
    </div>
  );
}
